import React from 'react'
import Layout from '../components/Layout'
import Seo from '../components/Seo'

export default () => (
	<Layout>
		<Seo title="About" keywords={[`blog`, `gatsby`, `javascript`, `react`]} />
		<div className="inner-wrap-container">
			<div className="inner-wrap visible animate fade-in">
				<div className="single-article">
					{/* OPTIONAL: Featured Image: */}
					<div
						className="featured-image"
						style={{
							backgroundImage: `url(https://source.unsplash.com/random/1024)`,
						}}
					/>
					{/* OPTIONAL: Featured Image: */}

					<div className="post-content m-auto">
						<h1 className="title">About</h1>
						<div className="content">
							<p>
								<strong>Nova</strong> is a Modern, highly content focus blog and
								magazine theme for GatsbyJS. The design is done keeping content
								and writer in mind. This theme is fully responsive means it will
								fit in various device of different size. Using{' '}
								<strong>Nova</strong> theme you can transform your regular
								GatsbyJS blog into a eye soothing web appearance. It is not only
								beautiful but also nice user experience for your audience.
							</p>
							<p>
								Installing and customizing this theme is very easy. All required
								information are provided in documentation.
							</p>
							<h3 id="features-of-this-theme">Features Of this theme</h3>
							<ul>
								<li>Modern, highly content focused, minimal design.</li>
								<li>Reader friendly and eye soothing.</li>
								<li>100% responsive, looks nice in any size of device.</li>
								<li>
									Fast page loading Tested with{' '}
									<strong>Google page speed insight</strong> and{' '}
									<strong>pingdom</strong>.
								</li>
								<li>
									<strong>Valid HTML5 coding.</strong>
								</li>
								<li>Supports image logo.</li>
								<li>Blog description.</li>
								<li>Previous and next post link in single post view.</li>
								<li>Supports inbuilt navigation system.</li>
								<li>Tag image.</li>
								<li>Author avatar, bio and social links.</li>
								<li>
									Custom <strong>tag archive</strong> page.
								</li>
								<li>Search functionality using Elastic Search.</li>
								<li>Responsive youtube, vimeo, soundcloud, mixcloud.</li>
								<li>Beautiful Code Highlight.</li>
								<li>Static pages.</li>
								<li>Custom error page.</li>
								<li>Cross-Browser Compatibility.</li>
								<li>Comment with disqus.</li>
								<li>Post sharing.</li>
								<li>Google font.</li>
								<li>SVG icons.</li>
								<li>Well commented and well structured coding.</li>
								<li>SCSS (CSS) file included, Easily achieve any color.</li>
								<li>Easy to customize.</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
)
